angular.module('sms', ['core'])
    .factory('SMS', function ($resource) {
        return $resource('crm/api/sms/:id', {id: '@id'}, {
            'sendMessage': {method: 'POST'}
        })
    })
    .service('SmsService', function (modals) {
        this.sendMessageToUser = user => {
            let smsModel = {
                phone: user.phone,
                resource: {
                    type: 'USER',
                    model: user
                }
            }
            return modals.open('app/sms/send-dialog.html', 'SmsSendDialogController', smsModel, {size: 'md'}, "$ctrl")
        }
        this.sendMessageToPhone = (phone, subjectName) => {
            let smsModel = {
                phone: phone,
                subjectName: subjectName
            }
            return modals.open('app/sms/send-dialog.html', 'SmsSendDialogController', smsModel, {size: 'md'}, "$ctrl")
        }
    })
